import { FETCH_MONITORED_DOCUMENT } from '../actions/MonitoredDocumentActions';

// INITIALIZE STATE
const initialState = {
    monitoredDocument: null,
    fetching: false,
    fetched: false,
    failed: false,
};

// REDUCER
export const MonitoredDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MONITORED_DOCUMENT}_PENDING`:
            return {
                ...state,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT}_FULFILLED`:
            return {
                ...state,
                monitoredDocument: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT}_REJECTED`:
            return {
                ...state,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
